<template>
    <div class="d-flex justify-content-end">
        <div v-if="isProfileLoaded">
            <div>{{profileDisplayName}}</div>
            <div>Point {{points}}</div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    name: "Topbar",
    computed: {
        ...mapState({
            isProfileLoaded: state => state.profile.isLoaded,
            profileDisplayName: state => state.profile.data.displayName,
            points: state => state.profile.data.updated_points.points,
        }),
    },
}
</script>
<style lang="scss" scoped>

</style>
